import { Routes } from '@angular/router';
import { provideTranslocoScope } from '@jsverse/transloco';
import { staffSessionGuard } from './shared/guards/staff-session/staff-session.guard';
import { AdminShellComponent } from './admin/pages/admin-shell/admin-shell.component';

export const APP_ADMIN_ROUTES: Routes = [
    {
        path: 'admin',
        component: AdminShellComponent,
        canActivate: [staffSessionGuard],
        providers: [...provideTranslocoScope('admin')],
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'clientes' },
            {
                path: 'clientes',
                loadComponent: () =>
                    import('./admin/pages/client-list/admin-client-list.component').then(
                        (module) => module.AdminClientListComponent,
                    ),
            },
            {
                path: 'clientes/:clientId',
                loadComponent: () =>
                    import('./admin/pages/admin-client-shell/admin-client-shell.component').then(
                        (module) => module.AdminClientShellComponent,
                    ),
                children: [
                    { path: '', pathMatch: 'full', redirectTo: 'perfil' },
                    {
                        path: 'perfil',
                        loadComponent: () =>
                            import('./admin/pages/client-basic-data/admin-client-basic-data.component').then(
                                (module) => module.AdminClientBasicDataComponent,
                            ),
                    },
                    {
                        path: 'eventos',
                        loadComponent: () =>
                            import('./admin/pages/client-events/admin-client-events.component').then(
                                (module) => module.AdminClientEventsComponent,
                            ),
                    },
                    {
                        path: 'consumo',
                        loadComponent: () =>
                            import('./admin/pages/client-usage/admin-client-usage.component').then(
                                (module) => module.AdminClientUsageComponent,
                            ),
                    },
                ],
            },
        ],
    },
];
